module.exports = __webpack_public_path__ + "static/media/susi_unagi.d7de227c.jpeg";